
import Animations from "../../Animations/animations";
import styles from "../Speacialities-Banner/speacialities-banner.module.css"

const SpecialitiesBanner = ({content}) => {
  return (
    <section className={styles.SpecialitiesBanner}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}>
            <h1>
            {content.heading}
            </h1>
           {content.subText != null && 
           <p>
           {content.subText}
       </p>
           }
            </Animations>
        </div>

    </section>
  );
};

export default SpecialitiesBanner;
